<template>
  <div>
    <div class="d-flex py-4">
      <div class="img_title_header ma-2 mr-4">
        <img src="@/assets/settings.png" height="" width="" />
      </div>
      <div class="title_menu pl-2">
        <h2>รายการจัดการ POS</h2>
      </div>
    </div>
    <div class="grid_custom mt-3 pl-4">
      <v-card class="list_menu_content" elevation="4">
        <router-link
          to="/reportwholesale"
          class="menu_card_content d-flex flex-column justify-center align-center"
        >
          <div class="img_menu_content">
            <img src="@/assets/arin_assets/shop.png" />
          </div>
          <div class="title_menu_content">ร้านค้าลูกค้าขายส่ง</div>
        </router-link>
      </v-card>
      <v-card class="list_menu_content" elevation="4">
        <router-link
          to="/setpriceinfomation"
          class="menu_card_content d-flex flex-column justify-center align-center"
        >
          <div class="img_menu_content">
            <img src="@/assets/arin_assets/cooperation.png" />
          </div>
          <div class="title_menu_content">ร้านค้าพาร์ทเนอร์</div>
        </router-link>
      </v-card>
      <v-card class="list_menu_content" elevation="4">
        <router-link
          to="/setrecordinfomation"
          class="menu_card_content d-flex flex-column justify-center align-center"
        >
          <div class="img_menu_content">
            <img src="@/assets/notifications-bell.png" />
          </div>
          <div class="title_menu_content">ประวัติความเคลื่อนไหวสินค้า</div>
        </router-link>
      </v-card>
      <v-card class="list_menu_content" elevation="4">
        <router-link
          to="/newsinformation"
          class="menu_card_content d-flex flex-column justify-center align-center"
        >
          <div class="img_menu_content">
            <img src="@/assets/picture_1.png" />
          </div>
          <div class="title_menu_content">จัดการข่าวสาร</div>
        </router-link>
      </v-card>
      <v-card
        class="list_menu_content"
        @click="dialog = true"
        style="cursor: pointer"
        elevation="4"
      >
        <span
          class="menu_card_content d-flex flex-column justify-center align-center"
        >
          <div class="img_menu_content">
            <img src="@/assets/increasing_refund.png" />
          </div>
          <div class="title_menu_content">Report Sales Out</div>
        </span>
      </v-card>

      <v-card class="list_menu_content" elevation="4">
        <router-link
          to="/history/sales-history"
          class="menu_card_content d-flex flex-column justify-center align-center"
        >
          <div class="img_menu_content">
            <img src="@/assets/arin_assets/analysis.png" />
          </div>
          <div class="title_menu_content">ประวัติการขายสินค้า</div>
        </router-link>
      </v-card>

      <v-card class="list_menu_content" elevation="4">
        <router-link
          to="/report/profit-loss"
          class="menu_card_content d-flex flex-column justify-center align-center"
        >
          <div class="img_menu_content">
            <img src="@/assets/money-bag-report.png" />
          </div>
          <div class="title_menu_content">รายงานกำไรขาดทุน</div>
        </router-link>
      </v-card>
      <div></div>
    </div>

    <v-dialog v-model="dialog" persistent max-width="520px">
      <v-card class="dialog-card">
        <v-card-title class="dialog-title d-flex align-center">
          <v-icon left color="#8cc63e" class="mr-2">mdi-calendar-month</v-icon>
          <span class="title-text">เลือกช่วงวันที่สำหรับ report</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="dialog-card pt-6 pb-1" ref="dialogCard">
          <v-form>
            <v-row dense :class="{ 'mb-2': !!startDate || !!endDate }">
              <v-col cols="12" md="6">
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startDate"
                      label="วันที่เริ่มต้น"
                      prepend-inner-icon="mdi-calendar"
                      clearable
                      readonly
                      outlined
                      dense
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    @input="menuStart = false"
                    no-title
                    scrollable
                    color="#8cc63e"
                  />
                </v-menu>
              </v-col>

              <v-col cols="12" md="6">
                <v-menu
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endDate"
                      label="วันที่สิ้นสุด"
                      prepend-inner-icon="mdi-calendar"
                      clearable
                      readonly
                      outlined
                      dense
                      :disabled="!startDate"
                      :hint="!startDate ? 'โปรดเลือกวันที่เริ่มต้นก่อน' : ''"
                      persistent-hint
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    @input="menuEnd = false"
                    :min="startDate"
                    no-title
                    scrollable
                    color="#8cc63e"
                  />
                </v-menu>
              </v-col>
            </v-row>

            <v-autocomplete
              ref="productAuto"
              v-model="selectedProducts"
              :items="productOptions"
              :loading="loadingProducts"
              label="ค้นหา/เลือกสินค้า (หลายรายการได้)"
              multiple
              clearable
              return-object
              item-text="label"
              item-value="value.id"
              hide-details="auto"
              outlined
              dense
              cache-items
              :search-input.sync="productSearch"
              @focus="prefetchOnce"
              :menu-props="{
                contentClass: 'product-select-menu',
                maxHeight: 320,
                maxWidth: 480,
                closeOnContentClick: false,
              }"
              :attach="$refs.dialogCard && $refs.dialogCard.$el"
              no-data-text="ไม่พบสินค้า"
            >
              <!-- สรุปว่าเลือกกี่รายการ -->

              <template v-slot:selection="{ item, index }">
                <!-- 3 ชิ้นแรก -->
                <v-chip v-if="index < 3" small class="ma-2">
                  {{ item.label }}
                </v-chip>

                <!-- ชิ้นที่ 4: ชิป + กล่อง div ชิดซ้าย -->
                <template
                  v-else-if="selectedProducts.length > 3 && index === 3"
                >
                  <v-menu
                    open-on-hover
                    offset-y
                    :close-on-content-click="false"
                    content-class="more-chip-menu"
                    transition="fade-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        small
                        class="ma-2"
                        color="grey lighten-3"
                        text-color="black"
                        v-on="on"
                        v-bind="attrs"
                      >
                        +{{ selectedProducts.length - 3 }} รายการ
                      </v-chip>
                    </template>

                    <!-- กล่อง div ที่ต้องการ -->
                    <div class="pa-2 menu-scroller">
                      <div
                        v-for="p in selectedProducts.slice(3)"
                        :key="p.value.id"
                        class="caption"
                        style="line-height: 1.2"
                      >
                        • {{ p.label }}
                        <span class="grey--text"
                          >({{ p.value.product_code }})</span
                        >
                      </div>
                    </div>
                  </v-menu>
                </template>
              </template>

              <!-- ไอเท็มแต่ละตัว (มีเช็คบ็อกซ์) -->
              <template v-slot:item="{ item, on, attrs }">
                <!-- แถวพิเศษ: สินค้าทั้งหมด -->
                <v-list-item
                  v-if="item?.value?.id === 'ALL'"
                  v-bind="attrs"
                  class="product-item"
                  @mousedown.prevent
                  @click.stop="selectedProducts = [item]"
                >
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="isAllSelected"
                      @change.stop="selectAllProducts(item)"
                      color="#8cc63e"
                      hide-details
                    />
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title
                      ><strong>สินค้าทั้งหมด</strong></v-list-item-title
                    >
                    <v-list-item-subtitle class="grey--text">
                      เลือกเฉพาะรายการนี้ และล้างตัวเลือกอื่นทั้งหมด
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <!-- แถวปกติ -->
                <v-list-item
                  v-else
                  v-bind="attrs"
                  v-on="{ ...on, click: () => {} }"
                  :key="item.value.id"
                  class="product-item"
                  @mousedown.prevent
                  @click.stop="toggleSelection(item)"
                >
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="isSelected(item)"
                      @change.stop="toggleSelection(item)"
                      color="#8cc63e"
                      hide-details
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                    <v-list-item-subtitle class="grey--text">
                      code: {{ item.value.product_code }} | id:
                      {{ item.value.id }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <!-- แถวท้ายสุด: ปุ่มโหลดเพิ่ม -->
              <template v-slot:append-item>
                <v-divider class="mb-2" />

                <div class="px-3 pb-3">
                  <v-btn
                    block
                    small
                    class="mb-2"
                    :loading="loadingMore"
                    :disabled="!hasMore || loadingMore"
                    @click.stop.prevent="loadMore()"
                  >
                    {{ hasMore ? "โหลดเพิ่มเติม" : "— สิ้นสุดรายการ —" }}
                  </v-btn>

                  <v-btn
                    block
                    small
                    color="#8cc63e"
                    class="white--text"
                    @click.stop.prevent="confirmProductSelection"
                  >
                    ตกลง
                  </v-btn>
                </div>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-text>

        <v-divider class="mt-3" />

        <v-card-actions class="px-6 py-4">
          <v-spacer />
          <v-btn
            color="grey darken-1"
            class="mr-2"
            text
            @click="dialog = false"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            class="white--text grad-success-bg"
            depressed
            @click="exportToExcel"
            :disabled="!startDate || !endDate"
          >
            <v-icon left>mdi-microsoft-excel</v-icon>
            Export เป็น Excel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Import ไลบรารี xlsx และ HTTP + SweetAlert2
import * as XLSX from "xlsx";
import { HTTP } from "@/axios.js";
import Swal from "sweetalert2";

export default {
  name: "MenuWebsite",
  data: () => ({
    dialog: false, // ตัวแปรสำหรับเปิด/ปิด Popup
    startDate: null, // เก็บวันที่เริ่มต้นที่เลือก
    endDate: null, // เก็บวันที่สิ้นสุดที่เลือก
    menuStart: false, // ควบคุมการแสดงผล Date Picker ของวันที่เริ่มต้น
    menuEnd: false, // ควบคุมการแสดงผล Date Picker ของวันที่สิ้นสุด

    selectedProducts: [],
    productOptions: [],
    loadingProducts: false,
    loadingMore: false,

    productSearch: "",
    searchTimer: null,

    nextCursor: null,
    hasMore: true,
  }),
  async mounted() {
    await this.loadProducts({ limit: 50 });
  },
  watch: {
    // Remote search + debounce
    productSearch(val) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(async () => {
        const q = (val || "").trim();

        // รีเซ็ต state ก่อนค้นหา
        this.productOptions = [];
        this.nextCursor = null;
        this.hasMore = true;

        if (q.length < 2) {
          await this.loadProducts({ limit: 50 });
        } else {
          await this.loadProducts({ q, limit: 50 });
        }
      }, 300);
    },
  },
  computed: {
    isAllSelected() {
      return this.selectedProducts.some((p) => p?.value?.id === "ALL");
    },
  },
  methods: {
    toast(message, icon = "info") {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon,
        title: message,
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
    },
    confirmProductSelection() {
      const auto = this.$refs.productAuto;
      if (!auto) return;

      // วิธีหลัก (Vuetify 2.x ส่วนใหญ่)
      if (typeof auto.isMenuActive !== "undefined") {
        auto.isMenuActive = false;
      }

      // เผื่อธีม/ไลบรารีบางตัว
      this.$nextTick(() => {
        if (
          auto.$refs &&
          auto.$refs.menu &&
          typeof auto.$refs.menu.isActive !== "undefined"
        ) {
          auto.$refs.menu.isActive = false;
        }
        // เอาโฟกัสออกจากช่องเพื่อกันเปิดเอง
        auto.blur && auto.blur();
      });
    },
    async ensureProductsLoaded() {
      // โหลดครั้งเดียวเมื่อผู้ใช้คลิก/โฟกัส select
      if (this.productOptions.length || this.loadingProducts) return;
      await this.loadProducts();
    },
    prefetchOnce() {
      if (!this.productOptions.length && !this.loadingProducts) {
        this.loadProducts({ limit: 50 });
      }
    },
    selectAllProducts(item) {
      // ล้างทั้งหมด แล้วเลือกแต่ "สินค้าทั้งหมด"
      this.selectedProducts = [item];
    },
    isSelected(item) {
      const id = item?.value?.id;
      return this.selectedProducts.some((p) => p?.value?.id === id);
    },
    toggleSelection(item) {
      // ถ้าคลิก "สินค้าทั้งหมด" → เคลียร์ทั้งหมดแล้วเหลือเฉพาะ ALL
      if (item?.value?.id === "ALL") {
        this.selectedProducts = [item];
        return;
      }

      // ถ้า ALL ถูกเลือกอยู่ แล้วคลิกสินค้าอื่น → เอา ALL ออกก่อน
      if (this.selectedProducts.some((p) => p?.value?.id === "ALL")) {
        this.selectedProducts = this.selectedProducts.filter(
          (p) => p?.value?.id !== "ALL"
        );
      }

      // toggle ปกติ
      const id = item?.value?.id;
      const idx = this.selectedProducts.findIndex((p) => p?.value?.id === id);
      if (idx === -1) {
        this.selectedProducts = [...this.selectedProducts, item];
      } else {
        const next = [...this.selectedProducts];
        next.splice(idx, 1);
        this.selectedProducts = next;
      }
    },
    // โหลดล็อตแรก/ค้นหา
    async loadProducts(params = { limit: 50 }) {
      try {
        this.loadingProducts = true;
        const { data } = await HTTP.get("/dashboards/getProductsForFilter", {
          params,
        });
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];
        const mapped = list.map((it) => ({
          label: it.product_name || it.name || it.product_code || `ID ${it.id}`,
          value: { id: it.id, product_code: it.product_code },
        }));

        const seen = new Set(this.productOptions.map((i) => i.value.id));
        this.productOptions = this.productOptions.concat(
          mapped.filter((i) => !seen.has(i.value.id))
        );

        // ใส่ "สินค้าทั้งหมด" ไว้บนสุด (ครั้งเดียว)
        const allOption = {
          label: "สินค้าทั้งหมด",
          value: { id: "ALL", product_code: "*" },
        };
        if (!this.productOptions.some((o) => o?.value?.id === "ALL")) {
          this.productOptions.unshift(allOption);
        }

        this.nextCursor = data?.next_cursor || null;
        this.hasMore = !!data?.has_more;
      } catch (e) {
        this.toast("โหลดรายการสินค้าไม่สำเร็จ", "error");
      } finally {
        this.loadingProducts = false;
      }
    },
    // โหลดต่อจาก cursor
    async loadMore() {
      if (!this.hasMore || !this.nextCursor) return;
      try {
        this.loadingMore = true;
        const params = { limit: 50, cursor: this.nextCursor };
        const q = (this.productSearch || "").trim();
        if (q.length >= 2) params.q = q;

        const { data } = await HTTP.get("/dashboards/getProductsForFilter", {
          params,
        });
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];
        const mapped = list.map((it) => ({
          label: it.product_name || it.name || it.product_code || `ID ${it.id}`,
          value: { id: it.id, product_code: it.product_code },
        }));

        const seen = new Set(this.productOptions.map((i) => i.value.id));
        this.productOptions = this.productOptions.concat(
          mapped.filter((i) => !seen.has(i.value.id))
        );

        this.nextCursor = data?.next_cursor || null;
        this.hasMore = !!data?.has_more;
      } catch (e) {
        this.toast("โหลดรายการสินค้าเพิ่มไม่สำเร็จ", "error");
      } finally {
        this.loadingMore = false;
      }
    },

    async exportToExcel() {
      if (!this.startDate || !this.endDate) {
        this.toast("กรุณาเลือกวันที่เริ่มต้นและสิ้นสุด", "warning");
        return;
      }

      const isAll = this.selectedProducts.some((p) => p?.value?.id === "ALL");
      const payload = {
        start_date: this.startDate,
        end_date: this.endDate,
        product_all: isAll ? 1 : 0,
        products: isAll
          ? []
          : this.selectedProducts.map((p) => ({
              id: p.value.id,
              product_code: p.value.product_code,
              label: p.label,
            })),
      };

      console.group("[Export] Payload -> backend");
      console.log(payload);
      console.groupEnd();

      let rows = [];

      try {
        const isAll = this.selectedProducts.some((p) => p?.value?.id === "ALL");

        // แยกค่าที่ต้องใช้เป็น query
        const ids = isAll ? [] : this.selectedProducts.map((p) => p.value.id);
        const codes = isAll
          ? []
          : this.selectedProducts.map((p) => p.value.product_code);

        // ใช้ GET + params ส่งไปเป็น query string
        const { data } = await HTTP.get("/dashboards/exportSellOut", {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            product_all: isAll ? 1 : 0,
            // ส่งรูปแบบ array ที่ Laravel ชอบ (ชื่อคีย์มี [] ที่ท้าย)
            ...(ids.length ? { "product_ids[]": ids } : {}),
            ...(codes.length ? { "product_codes[]": codes } : {}),
          },
          // (ตัวเลือก) หากอยากคุมการ serialize เอง:
          // paramsSerializer: params => new URLSearchParams(params).toString(),
        });

        const list = Array.isArray(data)
          ? data
          : data && Array.isArray(data.object)
          ? data.object
          : [];
        if (Array.isArray(list)) {
          rows = list.map((it) => ({
            productCode: it.product_code,
            productName: it.product_name,
            docDate: it.sale_date
              ? it.sale_date.split(" ")[0].split("-").reverse().join("/")
              : "",
            dailyType: it.sale_type,
            docNo: it.document_code,
            unit: it.unit_name,
            qtyDecrease: it.quantity,
          }));
        }
      } catch (e) {
        this.toast("ดึงข้อมูลจาก API ไม่สำเร็จ จะใช้ข้อมูล mock", "warning");
      }

      if (rows.length === 0) {
        this.toast("ไม่พบข้อมูลในช่วงวันที่ที่เลือก", "warning");
        return;
      }

      const now = new Date();
      const printDate = `${now.getDate()}/${
        now.getMonth() + 1
      }/${now.getFullYear()} ${now.getHours().toString().padStart(2, "0")}:${now
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
      const rangeText = `จากวันที่ : ${this.startDate}  ถึงวันที่ : ${this.endDate}`;

      const headerAoa = [
        ["บริษัท ฟาร์มาแคร์ พลัส จำกัด"],
        [rangeText],
        ["Title    : รายงานเคลื่อนไหวสินค้า"],
        ["Print By : system"],
        [`Print Date : ${printDate}`],
      ];

      const tableHeaderProduct = [["รหัสสินค้า", "ชื่อสินค้า", "หน่วยนับ"]];
      const tableHeaderMovement = [
        ["วันที่เอกสาร", "ประเภทรายวัน", "เลขที่เอกสาร", "หน่วยนับ", "จำนวนลด"],
      ];

      const grouped = [];
      const key = (r) => `${r.productCode}__${r.productName}`;
      const map = new Map();
      rows.forEach((r) => {
        const k = key(r);
        if (!map.has(k)) map.set(k, []);
        map.get(k).push(r);
      });

      map.forEach((arr) => {
        if (!arr.length) return;
        grouped.push([
          arr[0].productCode,
          arr[0].productName,
          arr[0].unit || "",
        ]);
        let sumProduct = 0;
        arr.forEach((m) => {
          const qty = Number(m.qtyDecrease) || 0;
          grouped.push([
            m.docDate,
            m.dailyType,
            m.docNo,
            m.unit || "",
            qty,
            m.lotNo || "",
          ]);
          sumProduct += qty;
        });
        grouped.push(["", "", "รวมจำนวนลดต่อสินค้า", "", sumProduct, ""]);
      });

      const aoa = [
        ...headerAoa,
        ...tableHeaderProduct,
        ...tableHeaderMovement,
        ...grouped,
      ];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 5 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 5 } },
        { s: { r: 4, c: 0 }, e: { r: 4, c: 5 } },
      ];
      ws["!cols"] = [
        { wch: 18 },
        { wch: 40 },
        { wch: 28 },
        { wch: 14 },
        { wch: 12 },
        { wch: 16 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ExportExcel");
      const fileName = `SalesOut_Layout_${this.startDate}_${this.endDate}.xlsx`;
      XLSX.writeFile(wb, fileName);
      this.toast("ส่งออกไฟล์สำเร็จ", "success");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.grid_custom {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-gap: 15px 0;
}

@media only screen and (max-width: 1000px) {
  .grid_custom {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}

@media only screen and (max-width: 500px) {
  .grid_custom {
    display: grid;
    grid-template-columns: 100%;
  }
}

.list_menu_content {
  width: 95%;
}

.list_menu_content:first-child {
  margin-right: 5px;
}

.list_menu_content:last-child {
  margin-left: 5px;
}

.router-link-active,
.list_menu_content:hover {
  background-image: linear-gradient(
    to right,
    #8cc63e,
    #91c657,
    #9cc66d
  ) !important;
  transition: 0.1s !important;
}

.list_menu_content:hover > .menu_card_content {
  color: #fff !important;
}

.menu_card_content {
  padding: 15px;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87) !important;
}

.img_menu_content {
  width: 100px;
}

.img_menu_content > img {
  max-width: 100%;
}

.title_menu_content {
  font-size: 20px;
}

.img_title_header {
  width: 50px;
}

.img_title_header > img {
  max-width: 100%;
}

.product-select-menu .v-list-item--active {
  background-color: transparent !important;
}

/* ช่องแสดงผลด้านบน: สรุปสั้น ๆ ไม่แตกบรรทัด */
/* เมนูของ v-select */
::v-deep .product-select-menu {
  max-width: 480px !important;
  overflow: hidden;
}

/* ให้ชื่อ/ซับไตเติลตัดบรรทัดได้ */
::v-deep .product-select-menu .v-list-item__title,
::v-deep .product-select-menu .v-list-item__subtitle {
  white-space: normal !important;
  word-break: break-word;
  line-height: 1.25;
}

/* ตัดสีไฮไลต์ของแถว active */
::v-deep .product-select-menu .v-list-item--active {
  background-color: transparent !important;
}

/* สรุปรายการที่เลือกด้านบน: ไม่ให้บวม */
.selection-summary {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-select__selections {
  max-height: 32px;
  overflow: hidden;
}

/* จัดแนวเนื้อหาแต่ละแถวให้แน่นขึ้น */
.product-item .v-list-item__content {
  margin: 0;
}

.product-item .v-list-item__subtitle {
  line-height: 1.2;
}

/* กล่องเมนู (popover) ให้ทึบดำ */
::v-deep .more-chip-menu {
  background: #000 !important;
  /* ดำทึบ */
  color: #fff !important;
  /* ตัวหนังสือขาว */
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  padding: 0 !important;
  min-width: auto !important;
}

/* กัน Vuetify วางชั้นในเป็นโปร่งใส (บางธีมใช้ .v-card/.v-sheet ข้างใน) */
::v-deep .more-chip-menu .v-sheet,
::v-deep .more-chip-menu .v-card {
  background: #000 !important;
  /* ดำทึบเหมือนกัน */
  color: #fff !important;
}

/* เนื้อหาที่คุณใส่ (div รายการ) ให้พื้นหลังทึบด้วย */
.menu-scroller {
  background: #414141;
  /* ดำทึบ ไม่โปร่งใส */
  color: #fff;
  max-width: 280px;
  max-height: 200px;
  overflow: auto;
  text-align: left;
  padding: 8px 10px;
  margin-top: 1%;
  /* ย้าย padding มาที่นี่ */
}

/* สีข้อความย่อยให้อ่านง่ายบนพื้นดำ */
::v-deep .more-chip-menu .grey--text {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>
